var _defs, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpoPresentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-872cbc1a-abd3-4959-b1ca-5a994fb08fd6",
    "data-name": "uuid-d9c9ddc0-1c79-4274-a49a-657b5d29d14c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4e4fd8df-a220-4bb3-8ebd-f107cf92e665",
    x1: 48.65,
    y1: 1044.85,
    x2: 56.35,
    y2: 1052.56,
    gradientTransform: "translate(0 -974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    className: "stop1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-df7d4036-01de-4ca2-9f4d-6bf9e08a7936",
    x1: 38.59,
    y1: 994.09,
    x2: 66.41,
    y2: 1021.91,
    gradientTransform: "translate(0 -974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    className: "stop1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7a5f624c-90fa-45c1-a112-59802c5099e8",
    x1: 34.29,
    y1: 1008.21,
    x2: 70.71,
    y2: 1044.62,
    gradientTransform: "translate(0 -974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    className: "stop1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5,76h-12c-.5,0-1-.4-1-1s.5-1,1-1h5v-6h2v6h5c.5,0,1,.4,1,1s-.5,1-1,1Z",
    fill: "url(#uuid-4e4fd8df-a220-4bb3-8ebd-f107cf92e665)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5,30h46c1.1,0,2,.9,2,2v4c0,1.1-.9,2-2,2H29.5c-1.1,0-2-.9-2-2v-4c0-1.1.9-2,2-2Z",
    fill: "url(#uuid-df7d4036-01de-4ca2-9f4d-6bf9e08a7936)",
    isolation: "isolate",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,38v28c0,1.1.9,2,2,2h40c1.1,0,2-.9,2-2v-28H30.5ZM43.5,56h-8c-.5,0-1-.5-1-1s.5-1,1-1h8c.5,0,1,.5,1,1s-.5,1-1,1ZM49.5,52h-14c-.5,0-1-.5-1-1s.5-1,1-1h14c.5,0,1,.5,1,1s-.5,1-1,1ZM70.5,60c0,.5-.4,1-1,1h-14c-.5,0-1-.5-1-1v-14c0-.5.5-1,1-1h14c.6,0,1,.5,1,1v14Z",
    fill: "url(#uuid-7a5f624c-90fa-45c1-a112-59802c5099e8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoPresentation);
export default __webpack_public_path__ + "static/media/expo_presentation.00d9d8c7ff19ede5144299ded7b76f87.svg";
export { ForwardRef as ReactComponent };